import React from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgChevronDown from '../../svg/icons/ChevronDown'
import { Button } from './Button'

type ShowMoreButtonProps = {
	itemsAmount: number
	handleClick: () => void
}

export const ShowMoreButton = React.memo(function ShowMoreButton(props: ShowMoreButtonProps) {
	const translate = useTranslate()

	return (
		<Button
			type={{ variant: 'underlinedGrey', large: true }}
			iconAfter={<SvgChevronDown />}
			onClick={props.handleClick}
			label={`${translate('showMoreButton.label')} (${props.itemsAmount})`}
		/>
	)
})
